import React from 'react';

interface KeyMetricProps {
  value: string;
  label: string;
  color?: string;
  size?: 'small' | 'medium' | 'large';
}

export const KeyMetric: React.FC<KeyMetricProps> = ({ 
  value, 
  label, 
  color = '#1e3a8a',
  size = 'large'
}) => {
  const getSizeClasses = () => {
    // If value is "Loading...", use smaller text
    if (value === "Loading...") {
      return 'text-sm';
    }
    
    switch (size) {
      case 'small':
        return 'text-2xl';
      case 'medium':
        return 'text-3xl';
      case 'large':
      default:
        return 'text-4xl';
    }
  };

  return (
    <div className="key-metric-item">
      <div 
        className={`key-metric-value ${getSizeClasses()}`}
        style={{ color }}
      >
        {value}
      </div>
      <div className="key-metric-label">
        {label}
      </div>
    </div>
  );
};

interface KeyMetricsProps {
  children: React.ReactNode;
  className?: string;
}

export const KeyMetrics: React.FC<KeyMetricsProps> = ({ children, className = '' }) => {
  return (
    <div className={`key-metrics-container ${className}`}>
      {children}
    </div>
  );
};

export default KeyMetrics;
